import React from 'react';

import {CheckboxSkeleton, FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const GroupSettingsSkeleton = () => (
    <Group direction="v">
        <FormItemSkeleton labelWidth={88}>
            <SkeletonItem width="100%" height={32}/>
        </FormItemSkeleton>
        <FormItemSkeleton labelWidth={82}>
            <SkeletonItem width="100%" height={32}/>
        </FormItemSkeleton>
        <FormItemSkeleton labelWidth={160}>
            <CheckboxSkeleton labelWidth={230}/>
        </FormItemSkeleton>
        <FormItemSkeleton labelWidth={188}>
            <Group direction="v" gap="xxs">
                <CheckboxSkeleton labelWidth={200}/>
                <CheckboxSkeleton labelWidth={200}/>
                <CheckboxSkeleton labelWidth={200}/>
                <CheckboxSkeleton labelWidth={200}/>
            </Group>
        </FormItemSkeleton>
        <FormItemSkeleton labelWidth={36}>
            <SkeletonItem width="100%" height={110}/>
        </FormItemSkeleton>
    </Group>
);
